var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.894,
    height: 20.421,
    viewBox: "0 0 21.894 20.421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-60.737 -624.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M81.089,634.788a1.256,1.256,0,0,0-.889.37l-3.575,3.565a2,2,0,0,1,.024.317,2.076,2.076,0,0,1-2.076,2.073H69.239a.279.279,0,0,1-.2-.081.281.281,0,0,1,0-.4.286.286,0,0,1,.2-.081h5.335a1.512,1.512,0,0,0,1.474-1.853h0l0-.013a1.5,1.5,0,0,0-1.471-1.153l-7.194,0h-.012a1.85,1.85,0,0,0-1.037.169l-1.851,1.08h0a.3.3,0,0,1-.04.02v4.863a2.05,2.05,0,0,1,.372.013,3.647,3.647,0,0,1,.647.153h0l.012,0,6.605,2.107a1.054,1.054,0,0,0,.266.047h0a.291.291,0,0,1,.046,0,1.246,1.246,0,0,0,.412-.069,1.4,1.4,0,0,0,.218-.1l.018-.01a1.224,1.224,0,0,0,.24-.189l8.7-8.683a1.242,1.242,0,0,0,0-1.773,1.255,1.255,0,0,0-.888-.37Z",
    transform: "translate(0.282 -1.755)",
    fill: "#280071"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M61.994,638.091a1.246,1.246,0,0,0-1.257,1.253v6.14a1.257,1.257,0,0,0,2.514,0v-6.14a1.246,1.246,0,0,0-1.257-1.253Z",
    transform: "translate(0 -2.314)",
    fill: "#280071"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 4.808,
    cy: 4.808,
    r: 4.808,
    transform: "translate(67.122 624.424)",
    fill: "#fff",
    stroke: "#280071",
    strokeMiterlimit: 10,
    strokeWidth: 0.843
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(70.325 627.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M72.561,627.994h2.8V628a4.277,4.277,0,0,1-.282.463h-.744a1.182,1.182,0,0,1,.209.5h.8c.009,0,.014.007.014.014-.179.3-.27.454-.275.456h-.514a1.5,1.5,0,0,1-.2.563,1.3,1.3,0,0,1-.459.432,1.625,1.625,0,0,1-.776.22v.007a1.259,1.259,0,0,0,.182.271l.817,1.091v.09a.012.012,0,0,1-.013.013h-.608a16.331,16.331,0,0,0-1.077-1.376V630.3l.007-.017a2.108,2.108,0,0,0,.339.024,1.055,1.055,0,0,0,1.143-.676.608.608,0,0,0,.034-.2h-1.66c-.009,0-.014-.005-.014-.017q.275-.454.282-.453h1.322v-.007a.817.817,0,0,0-.439-.4,1.227,1.227,0,0,0-.419-.086h-.738v-.017Q72.554,627.994,72.561,627.994Z",
    transform: "translate(-72.279 -627.994)",
    fill: "#171e59"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderIcon1);
export default __webpack_public_path__ + "static/media/header-icon-1.bd825bba4581b7bfc19c212151b11a45.svg";
export { ForwardRef as ReactComponent };